module.exports = __webpack_public_path__ + "static/img/propuestas-3.299d7c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/propuestas-3.jpg
// module id = hW2P
// module chunks = 1